import { render, staticRenderFns } from "./Regattas.vue?vue&type=template&id=36d993b0&scoped=true&"
import script from "./Regattas.vue?vue&type=script&lang=js&"
export * from "./Regattas.vue?vue&type=script&lang=js&"
import style0 from "./Regattas.vue?vue&type=style&index=0&id=36d993b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d993b0",
  null
  
)

export default component.exports